var version = {
    "name":      "dativery",
    "buildDateCode": "20260610-083921",
    "buildDate": "Wed Jun 10 2026 08:39:21 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260610-083921",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;